"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var TagPill = function TagPill(_ref) {
  var label = _ref.label,
      customClass = _ref.customClass,
      active = _ref.active,
      onUpdate = _ref.onUpdate;
  return (0, _preact.h)("button", {
    className: (0, _classnames.default)('tag--pill', customClass, {
      'tag--active': active
    }),
    onClick: function onClick() {
      return onUpdate(!active);
    }
  }, label);
};

var _default = TagPill;
exports.default = _default;